import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToTop, createScrollListener } from '../utils/scrollUtils';

/**
 * ScrollManager component provides global scroll management
 * beyond what ScrollToTop does, handling:
 * 1. Back/forward navigation memory
 * 2. Anchor link smooth scrolling
 * 3. Scroll tracking for analytics (optional)
 */
const ScrollManager = () => {
  const location = useLocation();

  useEffect(() => {
    // Track scroll depth for analytics (optional feature)
    let maxScrollDepth = 0;
    const handleScrollDepth = createScrollListener(() => {
      const currentScrollDepth = window.scrollY + window.innerHeight;
      const scrollPercent = Math.round(
        (currentScrollDepth / document.body.scrollHeight) * 100
      );
      
      if (scrollPercent > maxScrollDepth) {
        maxScrollDepth = scrollPercent;
        // You could send this to analytics when implemented
        // console.log(`Scroll depth: ${maxScrollDepth}%`);
      }
    }, 1000);

    window.addEventListener('scroll', handleScrollDepth);

    // Globally accessible scroll helpers
    window.scrollToSection = (id) => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    // Handle "back to top" buttons
    const backToTopButtons = document.querySelectorAll('[data-scroll="top"]');
    backToTopButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        scrollToTop({ smooth: true });
      });
    });

    // Fix for iOS Safari scroll position jumping
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isIOS) {
      document.documentElement.style.setProperty('--header-height', '80px');
    }

    // Update CSS variables
    document.documentElement.style.setProperty('--header-height', '80px');

    return () => {
      window.removeEventListener('scroll', handleScrollDepth);
      backToTopButtons.forEach(button => {
        button.removeEventListener('click', () => {});
      });
    };
  }, [location]);

  return null;
};

export default ScrollManager;
